var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.237,
    height: 40.3,
    viewBox: "0 0 40.237 40.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-whatsapp",
    transform: "translate(-3.862 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M4.9,43.3l2.7-9.8A18.942,18.942,0,0,1,37.4,10.6,18.759,18.759,0,0,1,43,24,18.992,18.992,0,0,1,24,43h0a19.209,19.209,0,0,1-9.1-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M4.9,43.8c-.1,0-.3-.1-.4-.1a.44.44,0,0,1-.1-.5L7,33.5a19.9,19.9,0,0,1-2.5-9.6A19.5,19.5,0,1,1,24,43.5a19.209,19.209,0,0,1-9.1-2.3L5,43.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M24,5A19.121,19.121,0,0,1,43,24,18.992,18.992,0,0,1,24,43h0a19.209,19.209,0,0,1-9.1-2.3l-10,2.6,2.7-9.8A18.926,18.926,0,0,1,24,5m0,38h0m0,0h0M24,4h0A20.059,20.059,0,0,0,4,24a18.853,18.853,0,0,0,2.5,9.6L3.9,43a1.015,1.015,0,0,0,.3,1,.908.908,0,0,0,.7.3h.3l9.7-2.5A19.51,19.51,0,0,0,24.1,44,20.011,20.011,0,0,0,38.3,9.9,20.293,20.293,0,0,0,24,4Z",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M35.2,12.8A15.561,15.561,0,0,0,24,8.2,15.834,15.834,0,0,0,8.2,24a15.5,15.5,0,0,0,2.4,8.4l.4.6L9.4,38.8l6-1.6.6.3a16.034,16.034,0,0,0,8,2.2h0A15.834,15.834,0,0,0,39.8,23.9,15.671,15.671,0,0,0,35.2,12.8Z",
    fill: "#40c351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M19.3,16c-.4-.8-.7-.8-1.1-.8h-.9a1.844,1.844,0,0,0-1.3.6,5.479,5.479,0,0,0-1.7,4,9.235,9.235,0,0,0,1.9,4.9c.2.3,3.3,5.3,8.1,7.2,4,1.6,4.8,1.3,5.7,1.2s2.8-1.1,3.2-2.3a4.36,4.36,0,0,0,.3-2.3c-.1-.2-.4-.3-.9-.6a30.012,30.012,0,0,0-3.2-1.5.8.8,0,0,0-1.1.2c-.3.5-1.2,1.5-1.5,1.9a.668.668,0,0,1-1,.1A10.682,10.682,0,0,1,22,26.2a12.454,12.454,0,0,1-2.6-3.3c-.3-.5,0-.7.2-1,.2-.2.5-.6.7-.8.2-.3.3-.5.5-.8a.762.762,0,0,0,0-.8A35.89,35.89,0,0,1,19.3,16Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWa);
export default __webpack_public_path__ + "static/media/icon_wa.442c479ad7e628c430cf53a17e79ce8f.svg";
export { ForwardRef as ReactComponent };